// Send all the data collected from the popTesting workflow to poppernaut
// This includes full size photos with their ground truth labels, and any metadata we also want to store
var constructPayload = function(store, question) {
    const state = store.getState();

    // I only want the fullsize images
    const histories = state.questionHistory.filter(ans => ans.file.type === "image/jpeg");
    const files = histories.map(hist => hist.answer.file);

    // Get the answer objects with the corrected labels
    const labelAnswers = state.questionHistory.filter(ans => ans.questionID === "updateLabel");
    const labels = labelAnswers.map(q => {
        let popResponse = q.answer[0].value;
        let isCorrect = q.answer[1].value === "Yes";
        if (isCorrect) {
            return popResponse ? "truePOP" : "truePic";
        } else {
            return popResponse ? "falsePOP" : "falsePic";
        }
    });

    const metadataAnswer = state.questionHistory.filter(ans => ans.questionID === "metadata");
    const metadata = metadataAnswer[0].answer.map(a => a.fieldID + ":" + a.value);

    var formData = new FormData();
    for (let i = 0; i < files.length; i++) {
        formData.append("images", files[i]);
        formData.append("popLabels", labels[i]);
    }

    formData.append("metadata", metadata);

    return formData;
};

export { constructPayload };
